export const phoneRegExp = /^[2-9]\d{9}$/;
export const individualPanRegex = /^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]{1}$/;
export const nonIndividualPanRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const ifscRegex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
export const accountNumberRegex = /^[a-zA-Z0-9]{5,40}$/;
export const stringRegex = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
export const addressRegex = /^[a-zA-Z0-9\s-/',&()#:.']{0,}$/;
export const emailRegex = /^[a-zA-Z0-9](?!.*?[^\na-zA-Z0-9]{2})[^\s@]+@[^\s@]+\.[^\s@]+[a-zA-Z0-9]$/;
export const amountRegex = /^[1-9]{1}[0-9]+$/;
export const numberRegex = /^[0-9]+$/;
export const alphaNumeric = /^[a-zA-Z0-9]{0,}$/;
export const indianPin = /^[0-9]\d{5}$/;
export const arnCodeRegex = /^[ARN|DUM]{3}[-]{1}[a-zA-Z0-9]{0,}$/;
export const alphabetRegex = /[a-zA-Z]/
export const whiteSpaceOnlyRegex = /^\s+$/
export const universalMatchRegex = /.*/
export const leadingZeroDigitRegex = /^0\d/
export const gstRegex = /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]Z[0-9A-Z]$/;
export const cinRegex = /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;
export const aadhaarRegex = /[0-9]{12}$/;
export const aadhaarRegexLastFour = /^\d{4}$/
export const drivingLicenseRegex = /^[A-Za-z0-9]{1,20}$/
export const passportRegex = /^[A-Za-z0-9]{1,9}$/
export const alphaNumericWithSpace = /^[a-zA-Z0-9\s]+$/
export const noWhiteSpaceRegex = /^\S*$/